// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"____image__mainContent__N52o5"};